import React, { FC, ReactNode } from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import EmptyState from 'components/empty-state';
import { routes } from 'utils/routing';

import { Wrap } from './styled';

interface IOrdersEmptyProps {
  children?: ReactNode;
}

const OrdersEmpty: FC<React.PropsWithChildren<IOrdersEmptyProps>> = ({ children }) => {
  const { formatMessage } = useIntl();
  return (
    <Box flexGrow="1">
      <Wrap>
        <EmptyState
          header={formatMessage({ id: 'noOrdersItemsYet' })}
          subheader={formatMessage({ id: 'recentOrdersEmptySubHeader' })}
          linkTo={routes.menu}
          linkText={formatMessage({ id: 'startOrder' })}
        />
      </Wrap>
      {children}
    </Box>
  );
};

export default OrdersEmpty;
